module.exports = __webpack_public_path__ + "static/media/error-image-mobile.1ff71448.png";